import { Icon } from "../../../../../../../components";

export const UncheckedIcon = ({ className }: { className?: string }) => (
  <Icon
    icon={"CHECKBOX_BLANK_CIRCLE_OUTLINE"}
    size={0.8}
    className={className}
  />
);

export const CheckedIcon = ({ className }: { className?: string }) => (
  <Icon icon={"CHECKBOX_MARKED_CIRCLE"} size={0.8} className={className} />
);
